import { render } from "./AtencionesPorMedico.vue?vue&type=template&id=22d80b41&scoped=true"
import script from "./AtencionesPorMedico.vue?vue&type=script&lang=js"
export * from "./AtencionesPorMedico.vue?vue&type=script&lang=js"

import "./AtencionesPorMedico.vue?vue&type=style&index=0&id=22d80b41&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d80b41"]])

export default __exports__